import { render, staticRenderFns } from "./Lottery_Inner_Card.vue?vue&type=template&id=520975ba&scoped=true"
import script from "./Lottery_Inner_Card.vue?vue&type=script&lang=js"
export * from "./Lottery_Inner_Card.vue?vue&type=script&lang=js"
import style0 from "./Lottery_Inner_Card.vue?vue&type=style&index=0&id=520975ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520975ba",
  null
  
)

export default component.exports